import { render, staticRenderFns } from "./CkEditor.vue?vue&type=template&id=227bdf3c"
import script from "./CkEditor.vue?vue&type=script&lang=js"
export * from "./CkEditor.vue?vue&type=script&lang=js"
import style0 from "./CkEditor.vue?vue&type=style&index=0&id=227bdf3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports